<template>
 <!-- Modal -->
  <div class="content-box-gray card modal fade" id="display-video-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header title text-center">
          <button type="button" onclick="javascript::player.api('pause')" class="close" data-dismiss="modal" aria-label="Close">
            <small aria-hidden="true">&times;</small></button>
          <h6 class="modal-title" id="myModalLabel" v-html="videoTitle" ></h6>
        </div>
        <div class=" content modal-body">
          <div class="embed-responsive embed-responsive-16by9">
            <!-- <iframe id="video1" class="embed-responsive-item"  width="640" height="564" frameborder="0" src="https://player.vimeo.com/570780298" allow="autoplay; fullscreen" allowfullscreen></iframe>	-->
            <iframe id="video1" :src="videoURL"
width="560" height="315"
                frameborder="0" allow="autoplay; fullscreen" allowfullscreen> <!-- width="640" height="564" -->
            </iframe>
            <!-- <object id="video1" data='https://www.youtube.com/embed/nfk6sCzRTbM?autoplay=1' width='560px' height='315px'></object>
		-->
          </div><div id="textDisplay" v-if="displayText" v-html="displayText"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../event-bus';
export default {
    components:{

     },
    name: "VideoDisplayModal",
    data() {
        return {
            videoURL:'',
            videoTitle:'',
            displayText:'',
        }
    },

    props: {
    },
    mounted() {

// Listen for changes in translation content.  TODO BELOW THROWS AN ERROR ON SAVING translation.vue
        EventBus.$on('displayVideoModal', (data) => {
            console.error("Generic Video modal invoked");
            console.log("videoURL: " + data.videourl);
            console.log("video Title: " + data.title);
            console.log("displayText: " + data.displayText);
            this.videoURL = data.videourl;
            this.videoTitle = data.title;
            this.displayText = data.displayText? data.displayText:'';
            $('div#display-video-modal').modal('show');
        });
     this.setupVideoBGStop();//set a shutdown on closing the video popup (else the audio continues)

    },
    methods: {
        setupVideoBGStop() {
               //set a shutdown on closing the video popup (else the audio continues)
            $("#display-video-modal").on("hide.bs.modal", function(e) {
                $("#video1").attr("src", ""); // Remove the video source.
            });
        },
        cancel() {
            this.videoURL = '';
            $('div#display-video-modal').modal('hide');
        },

    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#ffc107;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
#textDisplay{
    font-size: x-small;
}

</style>
